import Image from 'next/image'
import React from 'react'

type InterviewQAProps = {
  number: number
  question: string
  answer: string
  imgUrl: string
  isTextLeft?: boolean
}

const InterviewQA: React.FC<InterviewQAProps> = ({
  number,
  question,
  answer,
  imgUrl,
  isTextLeft,
}) => {
  const questionNumber = number + 1 >= 10 ? number + 1 : '0' + (number + 1)
  return (
    <div className="interview_contents">
      <h2 className="question">
        <div className="number">{questionNumber}</div>
        <pre>{question}</pre>
      </h2>
      <div className={`answer ${isTextLeft ? 'contents_reverse' : ''} `}>
        <div className={`answer_text`}>
          <pre className={`${isTextLeft ? 'ml-8 sp:ml-0' : 'mr-8 sp:mr-0'} sp:mb-4`}>{answer}</pre>
        </div>
        <div className="answer_image">
          <Image
            src={imgUrl}
            alt={`${questionNumber}.${question}`}
            width={350}
            height={260}
            layout="raw"
          />
        </div>
      </div>
    </div>
  )
}

export default InterviewQA
